import React, { useTransition } from "react";
import axios from 'util/axios';
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faRotateRight, faCodeCompare } from "@fortawesome/free-solid-svg-icons";
import ModalPortal from "util/component/Modal";
import { Modal } from "util/component/Modal/Modal";
import Draggable from "react-draggable";
import { useTranslation } from "react-i18next";
import { ContentEditableDiv,ContentEditableDivDesc } from "util/component/Input";

const getUserList = async (sheetCode) => {
    const response = await axios.post(process.env.REACT_APP_API + "/pcsReview/retrieveCallUserList", {
        sheetCode,
    });
    const resultData = response.data.data.result;
    return resultData;
};

const RenderRowReply = (rowData) => {
    return (
        <li>
            <div className={"header"}>
                <p className={"name"}>{rowData.userNm}</p>
                <p className={"time"}>{rowData.createDt}</p>
                <div className={"content"} dangerouslySetInnerHTML={{ __html: rowData.content }} suppressHydrationWarning></div>
            </div>
        </li>
    );
};

const UserList = ({ user, userClick }) => {
    return (
        <div className={"reviewer-list-box"}>
            {user?.map((data, i) => (
                <div className={"reviewer-list-item"} key={`userData-${i}`} onClick={() => userClick(data)}>
                    {data.value} /<span className="global_bold global_pl_5">{data.label}</span> {(data.enDepartmentName ? "("+data.enDepartmentName+")" : "")}
                </div>
            ))}
        </div>
    );
};

const RenderRow = (rowData) => {
    const [ReplyView, SetReplyView] = React.useState(true);
    const [InputValue, SetInputValue] = React.useState("");
    const [ModalData, SetModalData] = React.useState(null);
    const userSelector = useSelector((store) => store.user);
    const externalAuth = userSelector.userAuth.filter((f) => f.code === "20")
    const [RevUserList, SetRevUserList] = React.useState(false);
    const RevUserRef = React.useRef(rowData.userList);
    const { t } = useTranslation(["page"]);
    const sheetCodeOwners = rowData.templateOwners?.filter((f) => f.sheetCode === rowData.sheetCode)

    const completeRender = React.useMemo(() => {
        const { cmptType } = rowData;
        if (cmptType === "R") {
            return <span>Not Complete</span>;
        } else if (cmptType === "C") {
            return <span>Completed</span>;
        }
    }, [rowData]);

    const SaveReivew = async () => {
        const { celNm, sheetCode, tempYn, revision, revNo, getData, revtype, groupId } = rowData;
        /*
            uniqueCode는 remark 이슈로 인해 , 로 여러개가 올 수 있다.
            따라서 uniqueCode는 따로 처리.
            데이터를 받아 올 때 : uniqueCode의 첫번째로만 조회(어차피 같은 값이 들어가야 하므로)
            데이터를 저장 할 때 : uniqueCode 수 만큼 반복하여 저장
        */
        let { uniqueCode } = rowData;
        // uniqueCode = uniqueCode.split(",");

        let response;
        const innerHtml = inputRef.current.innerHTML();
        
        try {
            const postData = {
                celNm: celNm,
                revContent: innerHtml,
                revLevel: 2,
                revision: revision,
                sheetCode: sheetCode,
                tempYn: tempYn,
                revNo: revNo,
                userId: userSelector.userId,
                revType: revtype,
                groupId:groupId,
            };
                response = await axios
                    .post(
                        process.env.REACT_APP_API + (rowData.admin ? "/pcsReview/saveReply" : "/pcsReview/createRevReply"),
                        {...postData, uniqueCode: uniqueCode}
                    )
                    .catch((Err) => console.err(Err));
                if (response.data.data.result !== "1") {
                    const modal = (
                        <Modal
                            onClose={() => {
                                SetModalData(null);
                            }}
                        >
                            {t(response.data.data.result)}
                        </Modal>
                    );
                    SetModalData(modal);
                    throw new Error("err")
                }

        } catch (e) {
            console.error(e);
        } finally {
            if (rowData.refresh) rowData.refresh();
            else getData();
            SetInputValue("");
        }
    };

    const HandleExternalSaveReview = async () => {
        const { celNm, sheetCode, tempYn, revision, revNo, getData, groupId, externalViewYn, revInfo,admin } = rowData;

        if (!admin) {
            if (userSelector.userId !== rowData.userId) {
                if(sheetCodeOwners[0].userId === rowData.loginUserId || rowData.pcsOwnerId === rowData.loginUserId){
                }else{
                    return;
                }
            }
            if (!(revInfo.reviewEnd === "N" && revInfo.reviewing === "I")) {
                return;
            }
        }

        if(rowData.commentType === "desc"){
            if(rowData.ownerUserId !== userSelector.userId){ return }
        }
        /*
            uniqueCode는 remark 이슈로 인해 , 로 여러개가 올 수 있다.
            따라서 uniqueCode는 따로 처리.
            데이터를 받아 올 때 : uniqueCode의 첫번째로만 조회(어차피 같은 값이 들어가야 하므로)
            데이터를 저장 할 때 : uniqueCode 수 만큼 반복하여 저장
        */
        let { uniqueCode } = rowData;
        let externalView;
        if(externalViewYn === "N"){externalView = "Y"}else{externalView = "N"}
        if(!externalViewYn){externalView = "Y"}

        let response;
        try {
            const postData = {
                celNm: celNm,
                revision: revision,
                sheetCode: sheetCode,
                revNo: revNo,
                groupId:groupId,
                externalViewYn : externalView
            };
            response = await axios
                .post(
                    process.env.REACT_APP_API + ("/pcsReview/externalViewChange"),
                    {...postData, uniqueCode: uniqueCode}
                )
        } catch (e) {
            console.error(e);
        } finally {
            if (rowData.refresh) rowData.refresh();
            else getData();
            SetInputValue("");
        }
    };

    const inputRef = React.useRef(null);

    const RevUserClick = (user) => {
        const textData = inputRef.current.innerHTML();

        const payloadHtml = `${textData?.substring(
            textData?.lastIndexOf("@"),
            -1
        )} <span class="bpl-reviewerspan" suppressContentEditableWarning={true} contenteditable="false" data-userid="${
            user.value
        }">@${user.label}</span>&nbsp;`;

        inputRef.current.innerHTML(payloadHtml);

        SetRevUserList(false);
        setTimeout(() => {
            inputRef.current.focus();
        }, 100);
    };

    const HandleKeyDownUserList = (e) => {

        const text = e.target.innerText;
        const text2 = text && text?.substr(-1);

        if (!RevUserList) {
            if (e.key === "@" || (text2 === "@" && e.key === "2")) {
                SetRevUserList(RevUserRef.current);
            }
            else if(text2 === "@"){
                SetRevUserList(RevUserRef.current);
            }
        }
        if (RevUserList) {
            if (text && text?.substring(text?.lastIndexOf("@"), text?.lastIndexOf("@") + 1) === "@") {
                SetRevUserList(
                    RevUserRef.current.filter(
                        (data) =>
                            data.label
                                .toLowerCase()
                                .indexOf(text.toLowerCase().substring(text.lastIndexOf("@") + 1, text.length)) !== -1
                    )
                );
            } else {
                SetRevUserList(false);
            }
        }
    };
    const HandleSaveReview = () => {
        if (inputRef.current.innerText()) SaveReivew();
    };
    const HandleComplete = async () => {
        const { celNm, revNo, cmptType, revision, sheetCode, tempYn, getData, revInfo, admin,commentType,groupId } = rowData;
        /*
            uniqueCode는 remark 이슈로 인해 , 로 여러개가 올 수 있다.
            따라서 uniqueCode는 따로 처리.
            데이터를 받아 올 때 : uniqueCode의 첫번째로만 조회(어차피 같은 값이 들어가야 하므로)
            데이터를 저장 할 때 : uniqueCode 수 만큼 반복하여 저장
        */
        let { uniqueCode } = rowData;
        // uniqueCode = uniqueCode.split(",");
        if (!admin) {
            if (userSelector.userId !== rowData.userId) {
                if(sheetCodeOwners[0].userId === rowData.loginUserId || rowData.pcsOwnerId === rowData.loginUserId){
                }else{
                    return;
                }
            }
            if (!(revInfo.reviewEnd === "N" && revInfo.reviewing === "I")) {
                return;
            }
        }
        let response;
        const postData = {
            celNm: celNm,
            cmptType: cmptType,
            revNo: revNo,
            revision: revision,
            sheetCode: sheetCode,
            tempYn: tempYn,
            
            userId: userSelector.userId,
            groupId:groupId
        };
        let url = "/pcsReview/modifyRevCmptType";
        if(commentType === "desc"){
            url = "/pcsReview/modifyCmptType";
        }else{
            url = "/pcsReview/modifyRevCmptType";
        }
        try {
           response = await axios
                .post(process.env.REACT_APP_API + url, {...postData, uniqueCode: uniqueCode})
                .catch((Err) => console.err(Err));
            if (response.data.data.result !== "1") {
                const modal = (
                    <Modal
                        onClose={() => {
                            SetModalData(null);
                        }}
                    >
                        {t(response.data.data.result)}
                    </Modal>
                );
                SetModalData(modal);
                throw new Error("err");
            }
        } catch (e) {
            console.error(e);
        } finally {
            getData();
            SetInputValue("");
        }
    };

    return (
        <li className={`${rowData.cmptType === "C" ? "completed" : ""}`}>
            <div className={`d-flex justify-between wrap`}>
                <div className={"header"}>
                    <p className={"name"}>{rowData.userNm}</p>
                    <p className={"time"}>{rowData.createDt}</p>
                </div>
                { rowData.commentType !== "desc"? (
                    (sheetCodeOwners[0].userId === rowData.loginUserId) || (rowData.pcsOwnerId === rowData.loginUserId) ? (
                          <div
                              className={`info true ${rowData.cmptType}`}
                              onClick={HandleComplete}
                          >
                              {completeRender}
                          </div>
                      ):(
                          <div
                            className={`info ${
                                userSelector.userId === rowData.userId &&
                                rowData.revInfo?.reviewEnd === "N" &&
                                rowData.revInfo?.reviewing === "I"
                            } ${rowData.cmptType}`}
                            onClick={HandleComplete}
                          >
                            {completeRender}
                          </div>
                      )
                ) : rowData.tempYn === "Y" && (rowData.ownerUserId === userSelector.userId)? (
                    <div
                        className={`info ${
                            userSelector.userId === rowData.userId &&
                            rowData.revInfo?.reviewEnd === "N" &&
                            rowData.revInfo?.reviewing === "I"
                        } ${rowData.cmptType}`}
                        onClick={HandleComplete}
                    >
                        {completeRender}
                    </div>
                ) : ""}
                {externalAuth?.length === 0 ? (
                    <div className={`radio-group`}>
                        <input
                            type="checkbox"
                            id={`externalCmp`}
                            checked={rowData.externalViewYn === "Y"}
                            onChange={(e) => {}}
                            onClick={() => {
                                HandleExternalSaveReview();
                            }}
                        />
                    <label htmlFor={`userTypeAll`}>external</label>
                    </div>
                    ) : null
                }
                <div className={"content"} dangerouslySetInnerHTML={{__html: rowData.content}}
                     suppressHydrationWarning></div>
            </div>
            <div className={`rereply-wrapper ${ReplyView ? "" : "hide"} ${RevUserList ? "on" : ""}`}>
                {rowData?.comn.length > 0 && <div className={"rereply-hidebtn"} onClick={() => SetReplyView(!ReplyView)}></div>}
                <ul className={"review rereply-list"}>
                    {rowData?.comn.map((rowData2, index2) => {
                        return <RenderRowReply key={`rereply-${index2}`} {...rowData2} />;
                    })}
                </ul>
                {rowData.revInfo?.reviewing === "I" &&
                    rowData.revInfo?.reviewEnd === "N" &&
                    rowData?.cmptType !== "C" &&
                    rowData?.tempYn === "Y" && (
                        <div className={"review  input-group"}>
                            {rowData.commentType === "desc" ? (
                                (rowData.ownerUserId === userSelector.userId) ? (
                                    <div className={"reply-arrow"}>
                                        <div className={"reviewer-select-wrapper"}>
                                            {rowData.commentType === "desc" ? (
                                                <ContentEditableDivDesc onKeyUp={HandleKeyDownUserList} ref={inputRef}/>
                                            ) : <ContentEditableDiv onKeyUp={HandleKeyDownUserList} ref={inputRef}/>
                                            }
                                            {RevUserList && (
                                                <div className={"reviewer-list-wrapper"}>
                                                    <UserList user={RevUserList} userClick={RevUserClick}/>
                                                </div>
                                            )}
                                        </div>
                                        < button onClick={HandleSaveReview}>Send</button>
                                    </div>
                                ) : null
                            ) : <div className={"reply-arrow"}>
                                <div className={"reviewer-select-wrapper"}>
                                    {rowData.commentType === "desc" ? (
                                        <ContentEditableDivDesc onKeyUp={HandleKeyDownUserList} ref={inputRef}/>
                                    ) : <ContentEditableDiv onKeyUp={HandleKeyDownUserList} ref={inputRef}/>
                                    }
                                    {RevUserList && (
                                        <div className={"reviewer-list-wrapper"}>
                                            <UserList user={RevUserList} userClick={RevUserClick}/>
                                        </div>
                                    )}
                                </div>
                                < button onClick={HandleSaveReview}>Send</button>
                            </div>
                            }
                        </div>
                    )}
            </div>
            {ModalData && <ModalPortal>{ModalData}</ModalPortal>}
        </li>
    );
};

const ReviewComponent = (props) => {
    const {templateOwners, pcsOwnerId} = props;
    const sheetCodeOwners = templateOwners?.Owners?.filter((f) => f.sheetCode === props.sheetcd)
    const [Data, SetData] = React.useState(null);

    const [InputValue, SetInputValue] = React.useState("");
    const [Loading, SetLoading] = React.useState(false);
    const CanDragRef = React.useRef(false);
    const windowScroll = React.useRef(0);
    const baseScroll = React.useRef(0);
    const inputRef = React.useRef(null);
    const [ModalData, SetModalData] = React.useState(null);
    const userSelector = useSelector((store) => store.user);
    const externalAuth = userSelector.userAuth.filter((f) => f.code === "20")
    const [RevUserList, SetRevUserList] = React.useState(false);
    const RevUserRef = React.useRef([]);
    const { t } = useTranslation(["page"]);

    const getData = React.useCallback(async () => {
        SetLoading(true);
        const { master, sheetcd, revision, tempYn, cellnm, revtype, admin } = props;
        /*
            uniqueCode는 remark 이슈로 인해 , 로 여러개가 올 수 있다.
            따라서 uniqueCode는 따로 처리.
            데이터를 받아 올 때 : uniqueCode의 첫번째로만 조회(어차피 같은 값이 들어가야 하므로)
            데이터를 저장 할 때 : uniqueCode 수 만큼 반복하여 저장
        */
        let { uniqueCode } = props;
        // uniqueCode = uniqueCode.split(",");
        let revInfo;

        if (admin) {
            revInfo = {
                reviewEnd: "N",
                reviewing: "I",
            };
        } else {
            revInfo = await axios
                .post(process.env.REACT_APP_API + "/pcsReview/retrieveCheckEndReview", master)
                .then((Response) => Response?.data?.data?.result);
        }
        const postData = {
            celNm: cellnm,
            revision: revision,
            sheetCode: sheetcd,
            tempYn: tempYn,
            // uniqueCode: uniqueCode[0],
            uniqueCode: uniqueCode,
            userId: master.userId,
            revType: revtype,
        };
        const dataInfo = await axios
            .post(process.env.REACT_APP_API + "/pcsReview/list", postData)
            .then((Response) => Response?.data?.data?.result);
        SetData((OLD) => ({ revInfo, dataInfo }));
        SetLoading(false);
    }, [props]);

    React.useEffect(() => {
        windowScroll.current = 0;
        baseScroll.current = window.scrollY;
        getData();
        getUserList(props.sheetcd).then((data) => {
            RevUserRef.current = data;
            SetRevUserList(false);
        });
    }, [getData, props]);

    React.useEffect(() => {
        if (!Loading) {
            SetInputValue("");
            SetRevUserList(false);
            inputRef.current?.focus();
        }
    }, [Loading]);

    React.useEffect(() => {
        if(RevUserList && RevUserList.length < 1){
            SetRevUserList(false);
        }
    }, [RevUserList]);


    const HandleKeyDown = (e) => {
        if (e.code.toString().toLowerCase() === "escape") {
            props.close(null);
        }
        // if (e.target.tagName !== "INPUT") {
        //     props.close(null);
        // }
    };

    const RevUserClick = (user) => {
        const textData = inputRef.current.innerHTML();

        const payloadHtml = `${textData?.substring(
            textData?.lastIndexOf("@"),
            -1
        )} <span class="bpl-reviewerspan" suppressContentEditableWarning={true} contenteditable="false" data-userid="${
            user.value
        }">@${user.label}</span>&nbsp;`;

        inputRef.current.innerHTML(payloadHtml);

        SetRevUserList(false);
        setTimeout(() => {
            inputRef.current.focus();
        }, 100);
    };

    const HandleKeyDownUserList = (e) => {
        const text = e.target.innerText;
        const text2 = text && text?.substr(-1);

        if (!RevUserList) {
            if (e.key === "@" || (text2 === "@" && e.key === "2")) {
                SetRevUserList(RevUserRef.current);
            }
            else if(text2 === "@"){
                SetRevUserList(RevUserRef.current);
            }
        }
        if (RevUserList) {
            if (text && text?.substring(text?.lastIndexOf("@"), text?.lastIndexOf("@") + 1) === "@") {
                SetRevUserList(
                    RevUserRef.current.filter(
                        (data) =>
                            data.label
                                .toLowerCase()
                                .indexOf(text.toLowerCase().substring(text.lastIndexOf("@") + 1, text.length)) !== -1
                    )
                );
            } else {
                SetRevUserList(false);
            }
        }
    };

    React.useEffect(() => {
        window.addEventListener("keydown", HandleKeyDown);

        return () => {
            SetData(null);
            SetRevUserList(false);
            window.removeEventListener("keydown", HandleKeyDown);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderList = React.useMemo(() => {
        if (Data) {
            const { revInfo, dataInfo } = Data;
            if (dataInfo.length > 0) {
                return (
                    <ul className={"review"}>
                        {dataInfo?.map((rowData, index) => {
                            return (
                                <RenderRow
                                    {...rowData}
                                    admin={props.admin}
                                    refresh={props.refresh || getData}
                                    revInfo={revInfo}
                                    getData={props.refresh || getData}
                                    revtype={props.revtype}
                                    userList={RevUserRef.current}
                                    commentType = {props.commentType}
                                    ownerUserId = {props.ownerUserId}
                                    key={`reviewList${index}`}
                                    templateOwners={templateOwners?.Owners}
                                    loginUserId={props.master.userId}
                                    pcsOwnerId={pcsOwnerId}
                                />
                            );
                        })}
                    </ul>
                );
            } else {
                return <div className={"review-no"}>No Review</div>;
            }
        } else {
            return <div className={"review-no"}>No Review</div>;
        }
    }, [Data, getData]);

    const SaveReivew = async () => {
        const { cellnm, sheetcd, tempYn, revision,  revtype } = props;

        let externalSend = document.getElementById("externalSend")?.checked;
        if(externalSend === true){externalSend ="Y"} else externalSend ="N"
        if(externalAuth?.length !== 0){externalSend ="Y"}
        /*
            uniqueCode는 remark 이슈로 인해 , 로 여러개가 올 수 있다.
            따라서 uniqueCode는 따로 처리.
            데이터를 받아 올 때 : uniqueCode의 첫번째로만 조회(어차피 같은 값이 들어가야 하므로)
            데이터를 저장 할 때 : uniqueCode 수 만큼 반복하여 저장
        */
        let { uniqueCode } = props;
        // uniqueCode = uniqueCode.split(",");
        const innerHtml = inputRef.current.innerHTML();
        let response;
        const postData = {
            celNm: cellnm,
            revContent: innerHtml,
            revLevel: 1,
            revision: revision,
            sheetCode: sheetcd,
            tempYn: tempYn,
            userId: userSelector.userId,
            revType: revtype,
            externalViewYn : externalSend,
        };
        try {
               response = await axios
                    .post(process.env.REACT_APP_API + (props.admin ? "/pcsReview/save" : "/pcsReview/saveRev"), {...postData, uniqueCode: uniqueCode})
                    .catch((Err) => console.error(Err));
    
                if (response.data.data.result !== "1") {
                    const modal = (
                        <Modal
                            onClose={() => {
                                SetModalData(null);
                            }}
                        >
                            {t(response.data.data.result)}
                        </Modal>
                    );
                    SetModalData(modal);
                    throw new Error("err");
                }
        } catch (e) {
            console.error(e);
        } finally {
            SetInputValue("");
            if (props.refresh) props.refresh();
            else getData();
        }
    };

    const HandleSaveReview = () => {
        const text = inputRef.current.innerText();
        if (text) SaveReivew();
    };
    const OMD = () => {
        CanDragRef.current = true;
    };
    const OMU = () => {
        CanDragRef.current = false;
    };
    return (
        <>
        <Draggable
            onStart={() => {
                return CanDragRef.current;
            }}
        >
            <div
                className={"bpl-review-content-popup"}
                style={{ top: 150 - windowScroll.current, right: props.positionX, display: !Loading && Data ? null : "none" }}
            >
                {!Loading && Data && (
                    <div className={"bpl-review-content-popup-wrap"}>
                        <div className={"header"}>
                            <button className={"close"} onClick={props.refresh || getData}>
                                <FontAwesomeIcon icon={faRotateRight} fontSize={"1.2rem"} />
                            </button>
                            <div className={"draggable"} onMouseDown={OMD} onMouseUp={OMU}></div>
                            
                            <button className={"close"} onClick={() => props.close(null)}>
                                <FontAwesomeIcon icon={faClose} fontSize={"1.2rem"} />
                            </button>
                        </div>
                        <div className={"content"}>{renderList}</div>
                        <div className={"footer"}>
                            {Data?.revInfo?.reviewEnd === "N" && Data?.revInfo?.reviewing === "I" && props.tempYn === "Y" && props.commentType !=="desc"? (
                                <div className={"input-group review-input external-group"}>
                                    <div className={"reviewer-select-wrapper"}>
                                        <ContentEditableDiv onKeyUp={HandleKeyDownUserList} ref={inputRef}/>
                                        {RevUserList && (
                                            <div className={"reviewer-list-wrapper"}>
                                                <UserList user={RevUserList} userClick={RevUserClick}/>
                                            </div>
                                        )}
                                    </div>
                                    <button onClick={HandleSaveReview} disabled={Data?.revInfo.reviewEnd !== "N"}>
                                        Send
                                    </button>
                                    {externalAuth?.length === 0 ? (
                                        <div className={`radio-external`}>
                                            <input
                                                type="checkbox"
                                                id={`externalSend`}
                                            />
                                            <label htmlFor={`externalSend`}>external</label>
                                        </div>) : null
                                    }

                                </div>
                            ) : props.commentType === "desc" && props.ownerUserId === userSelector.userId && props.tempYn === "Y" ?
                                (<div className={"input-group review-input"}>
                                        <div className={"reviewer-select-wrapper"}>
                                            <ContentEditableDiv onKeyUp={HandleKeyDownUserList} ref={inputRef}/>
                                            {RevUserList && (
                                                <div className={"reviewer-list-wrapper"}>
                                                    <UserList user={RevUserList} userClick={RevUserClick}/>
                                                </div>
                                            )}
                                        </div>
                                        <button onClick={HandleSaveReview} disabled={Data?.revInfo.reviewEnd !== "N"}>
                                            Send
                                        </button>
                                        {externalAuth?.length === 0 ? (
                                            <div className={`radio-external`}>
                                                <input
                                                    type="checkbox"
                                                    id={`externalSend`}
                                                />
                                                <label htmlFor={`externalSend`}>external</label>
                                            </div>) : null
                                        }
                                    </div>
                                ) :
                                (
                                    <div className={"cannot-reviewable d-flex justify-center align-center"}>
                                        {t("cannotReviewWrite")}
                                    </div>
                                )}
                        </div>
                    </div>
                )}

                {ModalData && <ModalPortal>{ModalData}</ModalPortal>}
            </div>
        </Draggable>
        </>
    );
};

export default ReviewComponent;
